import { uiBase } from '../env/constants'

export const crmURL = uiBase +'crm'
